
export default function IconWrapper (props){
    return <>
    <div className={`flex items-center gap-18 ${props.className ?? ''}`}>
        {props.children}
    </div>
    </>
}